export const FILE_MAX_SIZE = 2097152
